var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgEmotionFilled24 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Zm3.5-12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM10 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-1.205 4.896.005.006c.005.008.017.022.033.042a4.952 4.952 0 0 0 .815.748c.578.42 1.376.808 2.35.808.975 0 1.772-.389 2.35-.808a4.951 4.951 0 0 0 .815-.748l.034-.042.004-.006a1 1 0 0 1 1.597 1.204l-.8-.6.8.601h-.001l-.001.002-.003.004-.007.01-.021.027-.07.085a6.944 6.944 0 0 1-1.171 1.08c-.798.58-2 1.192-3.526 1.192-1.525 0-2.728-.611-3.526-1.192a6.942 6.942 0 0 1-1.17-1.08 4.14 4.14 0 0 1-.07-.085l-.022-.028-.007-.009-.003-.004v-.001h-.001c0-.001 0-.002.8-.601l-.8.6a1 1 0 0 1 1.596-1.205Z",
    clipRule: "evenodd"
  })));
});
SvgEmotionFilled24.displayName = "SvgEmotionFilled24";
export default SvgEmotionFilled24;